import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAtlas } from "@/context/AtlasContext";
import { PageHeader } from "@/components/shared/PageHeader";
import { DataTable } from "@/components/shared/DataTable";
import { EmptyState } from "@/components/shared/EmptyState";
import { FormModal } from "@/components/shared/FormModal";
import { Button } from "@/components/ui/button";
import { Warehouse, Plus } from "lucide-react";
import { toast } from "sonner";

export default function Locations() {
  const { has } = useAtlas();
  const [locations, setLocations] = useState([]);
  const [open, setOpen] = useState(false);
  const canEdit = has("inventory.items.edit");
  const load = () => api.get("/inventory/locations").then((r) => setLocations(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const create = async (v) => { await api.post("/inventory/locations", v); toast.success("Location created"); load(); };
  return (
    <div>
      <PageHeader title="Inventory Locations" subtitle="Warehouses, stores and stocking points">
        {canEdit && <Button onClick={() => setOpen(true)} data-testid="location-create-button"><Plus className="w-4 h-4 mr-1" /> New Location</Button>}
      </PageHeader>
      {locations.length === 0 ? (
        <EmptyState icon={Warehouse} title="No locations yet" description="Create a location to hold inventory." actionLabel={canEdit ? "New Location" : undefined} onAction={() => setOpen(true)} />
      ) : (
        <DataTable testid="inventory-locations-table" columns={[
          { key: "name", header: "Location", render: (r) => <span className="font-medium text-slate-900">{r.name}</span> },
          { key: "code", header: "Code", mono: true, render: (r) => r.code || "—" },
          { key: "address", header: "Address", render: (r) => r.address || "—" },
        ]} rows={locations} />
      )}
      <FormModal open={open} onOpenChange={setOpen} title="New Location" testid="location-form-modal" onSubmit={create}
        fields={[{ name: "name", label: "Name", required: true }, { name: "code", label: "Code" }, { name: "address", label: "Address" }]} />
    </div>
  );
}
